import React, { useState, useContext } from 'react'
import './style.css'
import { MENUS } from '../../utils/constance'
import { useLocation, useNavigate } from 'react-router-dom'
import { Image } from 'antd'

import Logo from '../../assets/images/png/Logo.png'
import { MenuOutlined } from '@ant-design/icons'
import { MainStore } from '../../utils/store/context'

export default function Header() {

    const navigate = useNavigate()
    const location = useLocation()

    const { cart } = useContext(MainStore)

    const [isOpenResponsiveMenu, setIsOpenResponsiveMenu] = useState(false)

    return (
        <>
            <div className="header-container">
                <div onClick={() => navigate("/")} style={{ display: "flex", gap: 10, alignItems: "end", fontSize: 18, color: "#FD0097", cursor: "pointer" }}>
                    <Image src={Logo} width={50} preview={false} />
                    <b>BANGKOKGIFT.NET</b>
                </div>
                <div className="menus-container">
                    {MENUS.map((menu) => {
                        return <div style={{ position: "relative" }} className={`menu-content ${menu.path === "/" ? location.pathname === menu.path ? "menu-content-active" : "" : location.pathname.includes(menu.path) ? "menu-content-active" : ""}`}
                            onClick={() => {
                                setIsOpenResponsiveMenu(false)
                                navigate(menu.path)
                            }}
                        >
                            {menu.label}
                            {menu?.number_holder && cart > 0 && <div className="menu-number-holder">{cart}</div>}
                        </div>
                    })}
                </div>
                <div className="ham-berger-bar" onClick={() => setIsOpenResponsiveMenu(true)}>
                    <MenuOutlined style={{ fontSize: 24, color: "#FD0097", cursor: "pointer" }} />
                </div>

            </div >

            <div className={`menus-container-responsive ${isOpenResponsiveMenu ? "menu-responsive-active" : "menu-responsive-in-active"}`}>
                <div className="menus-bg-responsive" onClick={() => setIsOpenResponsiveMenu(false)}></div>
                <div className="menus-inner-responsive">
                    <div onClick={() => {
                        navigate("/")
                        setIsOpenResponsiveMenu(false)
                    }} style={{ display: "flex", cursor: "pointer", gap: 10, alignItems: "center", fontSize: 18, color: "#FD0097", justifyContent: "center", borderBottom: "4px solid #FD0097", paddingBottom: 20 }}>
                        <Image src={Logo} width={50} preview={false} />
                        <b>BANGKOKGIFT.NET</b>
                    </div>
                    {MENUS.map((menu) => {
                        return <div style={{ position: "relative" }} className={`menu-content ${menu.path === "/" ? location.pathname === menu.path ? "menu-content-active" : "" : location.pathname.includes(menu.path) ? "menu-content-active" : ""}`}
                            onClick={() => {
                                setIsOpenResponsiveMenu(false)
                                navigate(menu.path)
                            }}
                        >
                            {menu.label}
                            {menu?.number_holder && cart > 0 && <div className="menu-number-holder">{cart}</div>}
                        </div>
                    })}
                </div>
            </div>
        </>
    )
}
